export const update = <T, K extends keyof T>(
  arr: T[],
  key: K,
  id: T[K],
  updater: (item: T) => T
): T[] => {
  return arr.map((item) => (item[key] === id ? updater(item) : item));
};
